"use client"

import styles from "../../index.module.scss"
import { useSuffix } from "../../SuffixContext"
import { AdComponentTypes } from "../../types"

const getFloatClass = (index: number): string => {
  switch (index) {
    case 0:
      return styles.adFloat1 ?? ""
    case 1:
      return styles.adFloat2 ?? ""
    case 2:
      return styles.adFloat3 ?? ""
    case 3:
      return styles.adFloat4 ?? ""
    default:
      return ""
  }
}

export default function Couplet(props: AdComponentTypes) {
  const { AdList, style } = props
  const suffix = useSuffix()
  return (
    <>
      {AdList.adverts?.map((item, index) => (
        <div className={`${styles.adsDlDetail} ${getFloatClass(index)}`} id="ads-dl-detail" key={index} style={style}>
          <div
            className={item.is_inner == 0 ? styles.artLabelImg : ""}
            style={{
              position: "relative",
            }}
          >
            <a href={item.link_url} target="_blank" rel="noreferrer">
              <img src={`${item.pic_url}${suffix || ""}`} title="" alt={item.name} height="200" width="100" />
            </a>
          </div>
        </div>
      ))}
    </>
  )
}
